export const setPlatformUrlParam = (platformUrl: string, key: string, value: string): string => {
  if (!platformUrl.includes('#')) {
    const url = new URL(platformUrl);
    url.searchParams.set(key, value);
    return url.toString();
  }

  const [base, hash = ''] = platformUrl.split('#');
  const [hashPath, hashQuery = ''] = hash.split('?');
  const params = new URLSearchParams(hashQuery);
  params.set(key, value);

  return `${base}#${hashPath}?${params.toString()}`;
};

export const appendPlatformToken = (platformUrl: string, platformToken: string): string =>
  setPlatformUrlParam(platformUrl, 'tkn', platformToken);

export const setPlatformLanguage = (platformUrl: string, language: string): string =>
  setPlatformUrlParam(platformUrl, 'l', language);
